import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

interface Position {
  x: number;
  y: number;
}

@Directive({ selector: '[appAdjustMenuPosition]' })
export class AdjustMenuPositionDirective implements OnChanges {
  @Input() position: Position;

  constructor(private readonly elementRef: ElementRef) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.position?.currentValue) {
      this.adjustMenuPosition();
    }
  }

  private adjustMenuPosition() {
    if (this.elementRef.nativeElement && this.position) {
      requestAnimationFrame(() => {
        const menuElement = this.elementRef.nativeElement;
        const rect = menuElement.getBoundingClientRect();

        const windowWidth = window.frameElement ? window.frameElement.clientWidth : window.innerWidth;
        const windowHeight = window.frameElement ? window.frameElement.clientHeight : window.innerHeight;

        const rightOffset = 60;
        if (this.position.x + rect.width + rightOffset > windowWidth) {
          const leftSide = this.position.x - rect.width;
          if (leftSide >= 0) {
            menuElement.style.left = `${leftSide}px`;
          } else {
            menuElement.style.left = `${Math.max(windowWidth - rect.width - rightOffset, 0)}px`;
          }
        } else {
          menuElement.style.left = `${this.position.x}px`;
        }

        const topOffset = 70;
        if (this.position.y + rect.height + topOffset > windowHeight) {
          menuElement.style.top = `${Math.max(windowHeight - rect.height - topOffset, 0)}px`;
        } else {
          menuElement.style.top = `${this.position.y}px`;
        }

        menuElement.style.maxHeight = `${windowHeight - windowHeight / 10}px`;

        const scrollbar = menuElement.querySelector('.scrollbar') as HTMLElement;
        if (scrollbar) {
          scrollbar.style.height = `${windowHeight - windowHeight / 10}px`;
        }
      });
    }
  }
}